module.exports = __webpack_public_path__ + "img/approved-risk.dc74e6b6.png";